// src/project/data/fetches/balance.js
import { buildUrlWithAuth, RIDER_ENDPOINTS, getRiderId } from '../config/apiConfig'

export default {
  url() {
    const userId = getRiderId()
    // Nouveau endpoint V3 — retourne currentBalance et lastBalance
    return buildUrlWithAuth(RIDER_ENDPOINTS.BALANCE(userId))
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Success", data: { currentBalance: 8265, lastBalance: 7815, currency: "XOF", ... } }
    if (raw?.statusCode !== 200) {
      return { statusCode: 200, data: { balance: 0, currency: 'XOF' } }
    }
    const d = raw?.data || {}
    return {
      statusCode: 200,
      message: raw?.message || 'Success',
      data: {
        balance: d.currentBalance ?? d.availableBalance ?? 0,
        lastBalance: d.lastBalance ?? 0,
        currency: d.currency || 'XOF',
        lastUpdated: d.updatedAt || null,
        // Ces champs ne sont plus retournés par la V3, on les initialise à 0
        totalEarnings: 0,
        todayEarnings: 0,
        weekEarnings: 0,
        monthEarnings: 0,
        pendingEarnings: 0,
      },
    }
  },
}
